import { usePostFacilitiesQuery } from '../apis';
import { ReferenceKey } from '../enums';

export const useState = () => {
  const { data } = usePostFacilitiesQuery();

  const postcodes = data?.data.filter(
    ({ referenceKey }) => referenceKey === ReferenceKey.PostcodeCityState,
  );

  const getCityAndState = (postCode: string) => {
    const { city, state } =
      postcodes?.find(({ code }) => code === postCode) ?? {};
    return {
      city: city ?? '',
      state: state ?? '',
    };
  };

  return {
    getCityAndState,
  };
};
